import type {Entity,Tile} from '../engine/types';
import {facingToward} from '../engine/geometry';
function segment(entity:Entity,alpha:number){
 const path=entity.movementPath?.length?entity.movementPath:[entity.previous,entity.tile];
 const progress=Math.max(0,Math.min(1,alpha))*Math.max(0,path.length-1);
 const index=Math.min(Math.floor(progress),Math.max(0,path.length-2));
 return {from:path[index],to:path[index+1]??path[index],alpha:progress-index,steps:path.length-1};
}
export function interpolatedTile(entity:Entity,alpha:number):Tile{
 const s=segment(entity,alpha);
 return {x:s.from.x+(s.to.x-s.from.x)*s.alpha,y:s.from.y+(s.to.y-s.from.y)*s.alpha};
}
/** Tile velocity per simulation tick, including each segment of a run. */
export function movementVelocity(entity:Entity,alpha:number):Tile{
 const s=segment(entity,alpha);return {x:(s.to.x-s.from.x)*s.steps,y:(s.to.y-s.from.y)*s.steps};
}
export function movementFacing(entity:Entity,alpha:number):number{
 const s=segment(entity,alpha);return facingToward(s.from,s.to,entity.facing);
}
export function isMoving(entity:Entity){return entity.animation.id==='player.walk'||entity.animation.id==='player.run'||entity.animation.id==='healer.walk';}
